import { Box } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { starParts } from '../../../utils/score-stars';

/**
 * What a student sees after a reading.
 *
 * Stars rather than a percentage, because a number reads as a verdict and
 * these are children. The exact percentage is still what gets saved and what
 * a teacher sees, so nothing is lost by softening the display.
 *
 * `dir="rtl"` so the row fills from the right like everything else in the
 * Siddur, as an attribute rather than a style so the app's RTL plugin cannot
 * flip it back.
 */
const ScoreStars = ({ percentage, size = 32 }: { percentage: number; size?: number }) => {
  const { full, half, empty } = starParts(percentage);
  const colour = '#f2b705';

  return (
    <Box
      dir="rtl"
      role="img"
      aria-label={`${full + half * 0.5} כוכבים`}
      sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}
    >
      {Array.from({ length: full }, (_, i) => (
        <StarIcon key={`full-${i}`} sx={{ color: colour, fontSize: size }} />
      ))}
      {half === 1 && <StarHalfIcon sx={{ color: colour, fontSize: size }} />}
      {Array.from({ length: empty }, (_, i) => (
        <StarBorderIcon key={`empty-${i}`} sx={{ color: colour, fontSize: size }} />
      ))}
    </Box>
  );
};

export default ScoreStars;
